import { css } from '@emotion/react';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { getTokenValue } from '@atlaskit/tokens';

const familyNameStyle = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 1.25rem;
`;

export const familyHeaderStyle = css`
  font-weight: 500;
  padding-left: 1rem;
  ${getMediaDown('md')} {
    padding-top: 0.5rem;
  }
`;

export const familyContainer = css`
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: stretch;
  border-radius: 4px;
  ${familyNameStyle};
  border: 1px solid ${getColor('n50')};
  background: #fff;
  margin-bottom: 1.5rem;
  ${getMediaDown('md')} {
    align-items: flex-start;
    align-self: stretch;
  }
`;

export const productLogoNameContainer = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    &:first-of-type {
      flex-shrink: 0;
    }
    &:last-child {
      flex-shrink: 1;
      word-break: break-word;
    }
  }
  ${getMediaDown('md')} {
    align-items: flex-start;
    flex-direction: row;
    overflow-wrap: break-word;
    &:first-of-type {
      padding-top: 4px;
    }
  }
`;

export const productTreeContainer = css`
  padding-left: 16px;
`;

export const productHeaderContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 0 1rem 0;
  ${getMediaDown('md')} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
  }
`;

export const familyLogoWrapperStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: ${getColor('b300')};
  width: 2.25rem;
  height: 2.25rem;
`;

export const buttonStyle = css`
  color: ${getColor('b300')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: ${getTokenValue('space.200')};
  line-height: ${getTokenValue('space.250')};
  cursor: pointer;
  background: none;
  border: none;
  margin: 0 0 ${getTokenValue('space.025')};
  padding-right: ${getTokenValue('space.300')};
  ${getMediaDown('md')} {
    padding-bottom: 1rem;
  }
`;

export const pricingContainer = css`
  display: flex;
  height: 3.875rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 0.125rem;
  flex: 1 0 0;
`;

export const pricingMessageContainer = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1rem;
  font-weight: 400;
  border-left: 1px solid ${getColor('n50')};
  padding: 0 2.25rem;
  ${getMediaDown('md')} {
    display: flex;
    gap: 0.625rem;
    > div {
      width: 100%;
    }
  }
`;

export const productIconStyle = css`
  padding: 0rem 0.625rem;
  svg {
    width: 25px;
    height: 25px;
  }
`;
